export default (obj: Object | undefined) => {
    let isEmpty = true;
    if (obj == undefined) {
        return isEmpty;
    }

    for (const key of Object.keys(obj)) {
        if (obj[key] != undefined) {
            isEmpty = false;
        }
    }

    return isEmpty;
};



// WEBPACK FOOTER //
// ./src/helpers/isObjectEmpty.ts